// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { App } from '@capacitor/app';

export const useCapacitor = () => {
  useEffect(() => {
    // Only run on native platforms
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    let handleBackButton = null;
    let handleAppState = null;

    const initCapacitor = async () => {
      try {
        // Configure status bar
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: '#0f172a' });
        
        // Hide splash screen after app is ready
        await SplashScreen.hide();
      } catch (error) {
        console.log('Capacitor init error:', error);
      }

      // Handle back button on Android
      handleBackButton = await App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
        } else {
          App.exitApp();
        }
      });

      // Handle app state changes
      handleAppState = await App.addListener('appStateChange', ({ isActive }) => {
        console.log('App state changed. Is active?', isActive);
      });
    };

    initCapacitor();

    return () => {
      if (handleBackButton && typeof handleBackButton.remove === 'function') {
        handleBackButton.remove();
      }
      if (handleAppState && typeof handleAppState.remove === 'function') {
        handleAppState.remove();
      }
    };
  }, []);
};

export const isNative = () => Capacitor.isNativePlatform();
export const getPlatform = () => Capacitor.getPlatform();
